import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import { dateFormat } from 'utils/helpers/date'
import { toastSuccess } from 'utils/toast'
import {
  deleteInboundSchedule,
  getCountScheduled,
  GetInboundScheduleParamsType,
  getLocationDetail,
  getInboundScheduleApi,
  getAvailableSlotInboundScheduleApi,
} from 'features/Enterprise/CapacityHandler/services/inboundSchedule'
import { queryParamsURL } from 'utils/queryParamsURL'

export const SLICE_NAME = 'inboundSchedule'

export const fetchInboundSchedule = createAsyncThunk(
  `${SLICE_NAME}/fetchInboundSchedule`,
  async (_, { getState }) => {
    const {
      inboundSchedule: { filters },
    } = getState() as StoreStateType
    const params = {
      startDate: dateFormat({ date: filters.date[0], format: 'YYYY-MM-DD' }),
      endDate: dateFormat({ date: filters.date[1], format: 'YYYY-MM-DD' }),
      locationId: filters.location?.location_id,
      loadingDockId: filters.loadingDock?.id,
    } as GetInboundScheduleParamsType

    try {
      queryParamsURL.set(params)
      const { data: inboundScheduleData } = await getInboundScheduleApi(params)
      const { data: availableSlotData } = await getAvailableSlotInboundScheduleApi(
        params.loadingDockId,
      )

      const filteredInboundScheduleData = inboundScheduleData.data.map((item) => ({
        ...item,
        time_slot_data: item.time_slot_data.filter((ts) => ts.time_slot_type !== 'FCFS_CHILD'),
      }))

      return {
        inboundScheduleData: filteredInboundScheduleData,
        availableSlotData: availableSlotData.data?.filter((item) => item.is_active),
      }
    } catch (error) {
      callErrorMsg(error)
      return {
        inboundScheduleData: [],
        availableSlotData: [],
      }
    }
  },
)

export const fetchLocationDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchLocationDetail`,
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await getLocationDetail(id)

      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchCountScheduled = createAsyncThunk(
  `${SLICE_NAME}/fetchCountScheduled`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCountScheduled()
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const removeInboundSchedule = createAsyncThunk(
  `${SLICE_NAME}/removeInboundSchedule`,
  async (_, { rejectWithValue, getState }) => {
    const {
      inboundSchedule: { deleteSchedulePopUpState },
    } = getState() as StoreStateType

    try {
      const { data } = await deleteInboundSchedule(deleteSchedulePopUpState?.scheduleId || 0)

      toastSuccess(`${deleteSchedulePopUpState?.text} berhasil dihapus.`)

      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
